/* @flow */
import * as React from 'react';
import { inject, observer } from 'mobx-react';
import { translate } from 'react-i18next';

import type { TranslatorProps } from 'react-i18next';

import type { BrowserHistory } from 'history/createBrowserHistory';

import CentralForm from 'components/CentralForm/CentralForm.js';

import { AccountModel } from 'models/AccountModels.js';

type TypeWelcomeProps = {|
  accountModel: AccountModel,
  history: BrowserHistory,
  authenticationStore: Object,
|} & TranslatorProps;

const WelcomeMessage: (props: TypeWelcomeProps) => React.Element<*> =
  //eslint-disable-next-line
  ({ accountModel, t, api, history, authenticationStore }: TypeWelcomeProps): React.Element<*> => (
    <CentralForm>
      <form>
        <h1>{t('general:accounts.user_account_created')}</h1>
        {/*<p>{
                    t(`general:accounts.messages.${
                        (accountModel.additionalInfo || accountModel.accountNumbers)
                        ? 'welcome_trading' : 'welcome'
                    }`)
                }
                </p>*/}
        <p>{t('general:accounts.messages.welcome_pending')}</p>
      </form>
    </CentralForm>
  );

export default translate()(inject('accountModel', 'authenticationStore')(observer(WelcomeMessage)));
